// @flow

import React, { type Node, useCallback, useEffect, useState } from 'react';
import { getSafeBoletoBarcode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import styled, { css } from 'styled-components';
import Clipboard from 'react-clipboard.js';
import { Button } from '@tectonics/look-and-feel/shopify/commons/atoms';

export function CopyToClipboardButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <ButtonCopyToClipboard text={getSafeBoletoBarcode(incomingPayment)} />
  );
}

function ButtonCopyToClipboard({ text }: { text: string }): Node {
  const [copied, setCopied] = useState(false);
  const [timeoutId, setTimeoutId] = useState();

  useEffect(() => {
    return () => clearTimeout(timeoutId);
  }, [timeoutId]);

  const handleClick = useCallback(() => {
    setCopied(true);
    setTimeoutId(setTimeout(() => setCopied(false), 1500));
  }, [setCopied]);

  return (
    <CopyLinkButton as={Clipboard} type="info" outline={!copied} flat onClick={handleClick} data-clipboard-text={text}>
      <ButtonCopyToClipboardMessage copied={copied} />
    </CopyLinkButton>
  );
}

const CopyLinkButton = styled(Button)`
  background: #2397d4;
  color: white;
  font-size: 14px;
  font-weight: 700;
  margin: 10px 0;
  border-radius: 5px;
  width: 100%;
`;

const ButtonCopyToClipboardMessage = styled.p`
  position: relative;

  ::before {
    content: 'COPIAR CÓDIGO';
    opacity: 1;
    position: absolute;
    left: 0;
    right: 0;

    ${props => props.copied && css`
      opacity: 0;
    `}
  }
  ::after {
    content: 'COPIADO!';
    opacity: 0;

    ${props => props.copied && css`
        opacity: 1;
    `}
  }
`;
